import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-update-consultant',
  templateUrl: './modal-update-consultant.component.html',
  styleUrls: ['./modal-update-consultant.component.css']
})
export class ModalUpdateConsultantComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalUpdateConsultantComponent>
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }

}
